// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_signInBox__Psib2 {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  width: 410px;
  padding: 2.5rem;
  border-radius: 8px;
  background: #fff;
}

.style_parent__2lj2F {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f3f6f8;
}
.style_logo__HdDgH {
  position: absolute;
  top: 20px;
  left: 20px;
  object-fit: contain;
}
.style_headerBox__LT-9l {
  margin-bottom: 1rem;
}

.style_textBox__0r0Cy {
  display: flex;
  flex-direction: row;
  margin-top: 0.375rem;
}

.style_firstText__yVB4S {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  margin-right: 0.3rem;
}

.style_createAcc__e\\+\\+i0 {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  margin-right: 0.3rem;
  color: #5d87ff;
  cursor: pointer;
  text-decoration: none;
}

.style_loginWith__-CvA\\+ {
  display: flex;
  justify-content: space-between;
}

.style_iconBox__prkA7 {
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  width: 60px;
  height: 48px;
  border-radius: 5px;
  cursor: pointer;
}

.style_divider__qub-j {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.style_orText__8jbwU {
  font-size: 12px;
  font-weight: 500;
  width: "5%";
}

/* -------------------Input field style start------------ */

.style_inputField__jO-xy {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
}

.style_inputFieldForPass__4je8D {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
}
.style_passWrapper__EAf7j {
  position: relative;
}
.style_eyeIcon__BYkEQ {
  cursor: pointer;
  position: absolute;
  top: 13px;
  right: 10px;
}

.style_inputFieldForPass__4je8D:focus {
  outline: 2px solid rgb(195, 193, 193);
}
.style_inputField__jO-xy:focus {
  outline: 2px solid rgb(195, 193, 193);
}

/* -------------------Input field style end------------ */

.style_loaderRound__\\+U7H5 {
  width: 48px;
  height: 48px;
  border: 5px solid #bfbfbf;
  border-bottom-color: #FF3D00;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: style_rotation__-KDKk 1s linear infinite;
  }

  @keyframes style_rotation__-KDKk {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
  } `, "",{"version":3,"sources":["webpack://./src/components/SigninAndSignup/styles/style.module.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,2DAA2D;;AAE3D;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;;AAEA,yDAAyD;;AAEzD;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mDAAsC;EACtC;;EAEA;EACA;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;EACA","sourcesContent":[".signInBox {\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n  width: 410px;\n  padding: 2.5rem;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.parent {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f3f6f8;\n}\n.logo {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  object-fit: contain;\n}\n.headerBox {\n  margin-bottom: 1rem;\n}\n\n.textBox {\n  display: flex;\n  flex-direction: row;\n  margin-top: 0.375rem;\n}\n\n.firstText {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n  margin-right: 0.3rem;\n}\n\n.createAcc {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 600;\n  margin-right: 0.3rem;\n  color: #5d87ff;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.loginWith {\n  display: flex;\n  justify-content: space-between;\n}\n\n.iconBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n  width: 60px;\n  height: 48px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.divider {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n.orText {\n  font-size: 12px;\n  font-weight: 500;\n  width: \"5%\";\n}\n\n/* -------------------Input field style start------------ */\n\n.inputField {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n}\n\n.inputFieldForPass {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n}\n.passWrapper {\n  position: relative;\n}\n.eyeIcon {\n  cursor: pointer;\n  position: absolute;\n  top: 13px;\n  right: 10px;\n}\n\n.inputFieldForPass:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n.inputField:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n\n/* -------------------Input field style end------------ */\n\n.loaderRound {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #bfbfbf;\n  border-bottom-color: #FF3D00;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  }\n\n  @keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signInBox": `style_signInBox__Psib2`,
	"parent": `style_parent__2lj2F`,
	"logo": `style_logo__HdDgH`,
	"headerBox": `style_headerBox__LT-9l`,
	"textBox": `style_textBox__0r0Cy`,
	"firstText": `style_firstText__yVB4S`,
	"createAcc": `style_createAcc__e++i0`,
	"loginWith": `style_loginWith__-CvA+`,
	"iconBox": `style_iconBox__prkA7`,
	"divider": `style_divider__qub-j`,
	"orText": `style_orText__8jbwU`,
	"inputField": `style_inputField__jO-xy`,
	"inputFieldForPass": `style_inputFieldForPass__4je8D`,
	"passWrapper": `style_passWrapper__EAf7j`,
	"eyeIcon": `style_eyeIcon__BYkEQ`,
	"loaderRound": `style_loaderRound__+U7H5`,
	"rotation": `style_rotation__-KDKk`
};
export default ___CSS_LOADER_EXPORT___;
